import createIcon from '../../createIcon';

/**
 * @component @name Expand
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNCAyMEgyMFYyMkg0VjIwWk00IDJIMjBWNEg0VjJaTTEzIDlIMTZMMTIgNUw4IDlIMTFWMTVIOEwxMiAxOUwxNiAxNUgxM1Y5WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Expand = createIcon('Expand', [
  [
    'path',
    {
      d: 'M4 20H20V22H4V20ZM4 2H20V4H4V2ZM13 9H16L12 5L8 9H11V15H8L12 19L16 15H13V9Z',
      key: '1bktwf',
    },
  ],
]);

export default Expand;
